(function($, _) {
    'use strict';

    // --- 1. CONFIGURAZIONE ---
    
    
    // Variabile globale che (presumo) contiene l'ID della categoria corrente
    const CATEGORY_ID = (typeof ACTUAL_CATEGORY !== 'undefined') ? ACTUAL_CATEGORY : 0;
    
    // Selettore del plugin di caricamento prodotti (dal tuo script)
    const PLUGIN_SELECTOR = '[data-zg-role="get-product"]';
    
    // Selettore dei link ai prodotti
    const PRODUCT_LINK_SELECTOR = '[data-zg-role="product-link"]';

    // Chiavi per il sessionStorage (più pulito dei cookie per questo scopo)
    const POS_KEY = 'categoryScrollPosition';
    const PAGE_KEY = 'categoryPage';
    const CAT_KEY = 'categoryID';

    // Disabilita il ripristino automatico del browser
    if ('scrollRestoration' in history) {
        history.scrollRestoration = 'manual';
    }

    // --- 2. SALVATAGGIO DELLA POSIZIONE (AL CLICK SUL PRODOTTO) ---

    // Usiamo 'delegation' (document.on) perché i link dei prodotti 
    // vengono aggiunti dinamicamente con l'infinite scroll.
    $(document).on('click', PRODUCT_LINK_SELECTOR, function(event) {
        if (CATEGORY_ID !== 0) {
            // Troviamo l'istanza del plugin per ottenere la pagina corrente
            const productInfo = $(PLUGIN_SELECTOR).data('zg.getProductInfo');
            
            if (productInfo) {
                // Salviamo la posizione Y, la pagina corrente (es: 0, 1, 2...) e l'ID categoria
                sessionStorage.setItem(POS_KEY, window.scrollY);
                sessionStorage.setItem(PAGE_KEY, productInfo.page); // 'page' è la prop. interna del plugin
                sessionStorage.setItem(CAT_KEY, CATEGORY_ID);
            }
        }
    });

    // --- 3. RIPRISTINO DELLA POSIZIONE (AL CARICAMENTO DELLA PAGINA) ---

    // Ci agganciamo all'evento 'zg.getProductInfo.complete' che il tuo script
    // 'getProductInfo.js' lancia quando ha finito di caricare i prodotti (inizialmente, la pagina 0).
    // Usiamo .one() per eseguirlo solo la *prima* volta.
    $(document).one('zg.getProductInfo.complete', function() {
        

        console.log('back2');
        console.log()

        const savedPos = sessionStorage.getItem(POS_KEY);
        const savedPage = sessionStorage.getItem(PAGE_KEY);
        const savedCat = sessionStorage.getItem(CAT_KEY);

        console.log(savedPos);
        console.log(savedPage);
        console.log(savedCat);

        // Controlliamo se siamo sulla stessa categoria e se abbiamo dati validi
        if (!savedPos || !savedPage || !savedCat || savedCat != CATEGORY_ID) {
            // Nessun dato o categoria diversa: puliamo tutto e non facciamo nulla.
            sessionStorage.removeItem(POS_KEY);
            sessionStorage.removeItem(PAGE_KEY);
            sessionStorage.removeItem(CAT_KEY);
            return;
        }

        const savedPageNum = parseInt(savedPage, 10);
        const savedPosNum = parseInt(savedPos, 10);
        const productInfo = $(PLUGIN_SELECTOR).data('zg.getProductInfo');

        console.log('back3');
        if (!productInfo) {
            return; // Non dovrebbe succedere se l'evento è partito
        }

        // CASO 1: Eravamo a Pagina 0.
        // I prodotti sono già stati caricati. Dobbiamo solo scrollare.
        if (savedPageNum === 0) {
            
            console.log('back4');

            // Usiamo un piccolo timeout per sicurezza (lasciamo renderizzare)
            setTimeout(function() {
                $('html, body').animate({
                    scrollTop: savedPosNum
                }, 800, function() {
                    // Finito lo scroll, puliamo i dati
                    sessionStorage.removeItem(POS_KEY);
                    sessionStorage.removeItem(PAGE_KEY);
                    sessionStorage.removeItem(CAT_KEY);
                });
            }, 100);
        }
        
        // CASO 2: Eravamo in una pagina > 0 (il caso difficile!)
        // Dobbiamo forzare il plugin a caricare TUTTE le pagine fino a quella salvata.
        else {


            console.log('back5');
            
            // Disabilitiamo l'infinite scroll temporaneamente
            productInfo.stopScrollEvent = true;
            $(window).off('scroll.zg.pagination.loader');
            
            // Mostriamo il loader
            $('#page-loader').css('display', 'flex').hide().fadeIn(200);

            // Modifichiamo la richiesta *prima* di richiamare getInfo()
            // Questa logica imita quella presente in __processFilters
            // per il caricamento di più pagine in un colpo solo.
            productInfo.options.resetPages = true;
            productInfo.request.pageSize = productInfo.options.pageSize * (savedPageNum + 1);
            productInfo.request.page = 0;
            productInfo.options.emptyContainer = true; // Ricarichiamo tutto il contenitore

            // Ora ci prepariamo ad ascoltare il *prossimo* evento 'complete',
            // che segnalerà il completamento della nostra MEGA-richiesta.
            $(document).one('zg.getProductInfo.complete', function() {
                
                // Ora tutti i prodotti (da pag 0 a savedPageNum) sono nel DOM.
                // Possiamo finalmente scrollare.
                
                // Diamo un container 'min-height' per evitare "salti"
                // se la pagina non è ancora alta quanto la nostra posizione.
                const $container = $(productInfo.options.productsContainer || PLUGIN_SELECTOR);
                $container.css('min-height', savedPosNum + $(window).height());

                setTimeout(function() {
                    $('html, body').animate({
                        scrollTop: savedPosNum
                    }, 800, function() {
                        // Finito lo scroll, puliamo i dati
                        sessionStorage.removeItem(POS_KEY);
                        sessionStorage.removeItem(PAGE_KEY);
                        sessionStorage.removeItem(CAT_KEY);
                        
                        // Ri-abilitiamo l'infinite scroll
                        productInfo.stopScrollEvent = false;
                        $(window).on('scroll.zg.pagination.loader', { that: productInfo }, productInfo.__scrollOn);
                        
                        // Rimuoviamo il min-height
                        $container.css('min-height', '');
                    });
                }, 100); // Leggero ritardo per il rendering
            });

            // Svuotiamo la cache del plugin per forzare la nuova chiamata
            productInfo.cached = {}; 
            
            // Avviamo la nostra richiesta modificata
            productInfo.getInfo(true, false); 
        }
    });

}(jQuery, _));